import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import HeartbeartIcon from '../../icons/heartbeat.svg';
import Vitamins from '../../icons/Vitamins.svg';
import Baseball from '../../icons/Baseball.svg';
import Burger from '../../icons/Burger.svg';
import ButtonInput from '../Product/TermLifeInsurance/SubComponent/ButtonInput';
import Button from '@material-ui/core/Button';

const buttonData = [
    {
        icon: Vitamins,
        title: 'Exceptionally healthy (Preferred Plus)',
        infoText: 'No chronic health conditions, no hospitalization, no substance/alcohol abuse, few to no medications,superior height/weight.',
        sortText:"PP"
    },
    {
        icon: Baseball,
        title: 'Very healthy (Preferred)',
        infoText: 'Minor health conditions or no conditions, conditions are stable and well managed with no hospitalizations, no substance/alcohol abuse, few medications, good height/weight.',
        sortText:"P"
    },
    {
        icon: Burger,
        title: 'Above average health (Standard Plus)',
        infoText: 'Well managed chronic conditions, stable medication usage, no substance/alcohol abuse,average height/weight.',
        sortText:"RP"
    },
    {
        icon: HeartbeartIcon,
        title: 'Average health (Standard)',
        infoText: 'Stable chronic conditions, multiple medications can be acceptable, average to slightly below average height/weight, recent hospitalizations can be acceptable.',
        sortText:"R"
    },
    {
        icon: HeartbeartIcon,
        title: 'Below average health (Substandard)',
        infoText: 'More serious and/or multiple health conditions, unstable and not well managed, obese or morbid obesity, multiple medication usage.',
        sortText:"RR"
    }
];
export default function Health(props) {
    useEffect(() => {
        // control the Checkbox based on if knockouts are selected
        var selected = false;
        props.formState.knockouts.forEach((k) => {
            selected = selected || k
        });
    }, [props.formState.knockouts]);

    const handleValueChange = (value, index) => {
        let stateCopy;
        if (value)
            stateCopy = [...Array(buttonData.length).keys()].map((i) => false);
        else {
            stateCopy = props.formState.knockouts.slice(0);
        }
        stateCopy[index] = value;
        props.onFieldChange("knockouts", stateCopy);
    };

    useEffect(()=>{
        if (props.savedQuote) {
            let stateCopy = [...Array(buttonData.length).keys()].map((i) => false);
            const healthClassIndex = buttonData.findIndex((button) => button.sortText === props.savedQuote.HealthClass);
         
            stateCopy[healthClassIndex] = true;
            props.onFieldChange("knockouts", stateCopy);
        }
    },[])

    return (
        <Container fluid className='border-class'>
            <Form onSubmit={props.onNext}>
                <Row className='w-100 '>
                    <Col sm={12}>
                        <h4 className='justify-content-center text-center mt-5'>How is your client's health?</h4>
                    </Col>
                </Row>
                <Row className="justify-content-center no-gutters mb-5" role="group" aria-labelledby="Background">
                    {buttonData.map((d, index) =>
                        <Col xs="auto" key={index} className="d-flex mr-3 justify-content-center btn-wrapper">
                            <ButtonInput
                                icon={d.icon}
                                title={d.title}
                                subtitle=''
                                infoText={d.infoText}
                                index={index}
                                value={props.formState.knockouts[index]}
                                onClick={() => handleValueChange(!props.formState.knockouts[index], index)}
                            />
                        </Col>
                    )}
                </Row>
                <Row className="pt-5 mb-4 mx-2">
                    <Col className="text-left btn-back">
                        <Button variant="outlined" size="medium" color="primary" onClick={props.onBack} >BACK</Button>
                    </Col>
                    <Col className="text-right">
                        <Button variant="contained" size="medium" color="primary" disabled={!props.formState.knockouts.includes(true)} type="submit">NEXT</Button>
                    </Col>
                </Row>

            </Form>
        </Container>
    )
}

Health.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
};

Health.DefaultFormState = (prefill = false) => {
    return {
        knockouts: [...Array(buttonData.length).keys()].map((i) => false),
    };
};


// WEBPACK FOOTER //
// ./src/components/Common/Health.js